module.exports = __webpack_public_path__ + "static/media/metamask-logo.023762b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/metamask-logo.png
// module id = 787
// module chunks = 0